/** A real answer from identity that was not a success: its message, and the HTTP status. */
export class IdentityError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'IdentityError';
    this.status = status;
  }
}

/** The person belongs to several accounts for this product; sign in again naming one. */
export class AccountChoiceError extends Error {
  constructor(accounts) {
    super('Choose an account.');
    this.name = 'AccountChoiceError';
    this.accounts = accounts;
  }
}

/** Another tab refreshed this session a moment ago (identity's 409 refresh_in_progress). */
export class RefreshInProgressError extends Error {
  constructor() {
    super('This session was refreshed a moment ago.');
    this.name = 'RefreshInProgressError';
  }
}

/** Identity stayed busy or unreachable through every retry. Not a sign-out: try again later. */
export class IdentityUnavailableError extends Error {
  constructor() {
    super('Sign-in is busy right now. Please try again in a minute.');
    this.name = 'IdentityUnavailableError';
  }
}
